import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { GoogleMap } from "../GoogleMap/GoogleMap";
import GetDirectionsButton from "../Buttons/GetDirectionsButton";

const CourseCardIltInfo = ({ instructor, location }) => {
  return (
    <Box
      display="flex"
      flex={1}
      alignItems="flex-start"
      flexDirection={{ xs: "column", sm: "row" }}
      height={{ xs: 500, sm: "auto" }}
    >
      <Box display="flex" flexDirection="column" flex={1}>
        {instructor && (
          <Box mb={2.5}>
            <Typography variant="subtitle2" color="textPrimary">
              Instructor
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {instructor.name}
            </Typography>
          </Box>
        )}
        {!!location && (
          <Box mb={2.5}>
            <Typography variant="subtitle2" color="textPrimary">
              Location
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {location.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {location.address1}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {location.address2}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
            >{`${location.city}, ${location.state} ${location.zip}`}</Typography>
          </Box>
        )}
        {!!location && (
          <Box ml={-1}>
            <GetDirectionsButton location={location} />
          </Box>
        )}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        position="relative"
        height={215}
        width="100%"
      >
        {!!location && (
          <GoogleMap
            lng={location.lng}
            lat={location.lat}
            locationName={location.name}
          />
        )}
      </Box>
    </Box>
  );
};

export default CourseCardIltInfo;

CourseCardIltInfo.propTypes = {
  instructor: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  location: PropTypes.shape({
    name: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number
  })
};
